import { TOGGLE_EMAIL_MODAL } from "bundles/project/actions/index";

const initialState = { show: false, emails: null };

const EmailModal = (state = initialState, action) => {
  switch (action.type) {
  case TOGGLE_EMAIL_MODAL:
    return { ...action.payload };
  default:
    return state;
  }
};

export default EmailModal;
